import * as constants from '../constants/app';

/** App Actions */

/**
 * Sets the error
 * 
 * @export 
 * @param {string} error Error to set
 * @returns 
 */
export function setError (error) {
    return {
        type: constants.SET_ERROR,
        error
    }
}


// WEBPACK FOOTER //
// ./src/actions/app.js